import classNames from 'classnames'
import React, { FunctionComponent, PropsWithChildren } from 'react'

import styles from './Link.module.scss'

export interface IProps extends PropsWithChildren {
  href?: string
  className?: string
  onClick?: (e: any) => void
  color?: 'inherit' | 'primary' | 'secondary'
  target?: '_blank' | '_self' | '_parent' | '_top'
  rel?: 'noopener'
}

const Link: FunctionComponent<IProps> = ({
  href,
  children,
  className,
  color,
  target,
  onClick,
  rel,
}) => (
  <a
    rel={rel}
    className={classNames(
      styles.link,
      [
        {
          [styles.colorInherit]: color === 'inherit',
          [styles.colorPrimary]: color === 'primary',
          [styles.colorSecondary]: color === 'secondary',
        },
      ],
      className || ''
    )}
    href={href}
    target={target || '_self'}
    onClick={onClick}
  >
    {children}
  </a>
)

const LinkConnected = Link
export { LinkConnected as Link }
